module.exports = __webpack_public_path__ + "img/157.652b9bb0.png";